export default __webpack_public_path__ + "static/media/Username.4334c743.png";